/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  toValue.ts
 */

import { ExpirableStorageOptions } from '../types/ExpirableStorageOptions'
import { StoredData } from '../types/StoredData'

import { isValidStoredData } from './isValidStoredData'

export const toValue = <TValue = any>(
  data: StoredData<TValue>,
  options: ExpirableStorageOptions
) => {
  if (isValidStoredData(data, options)) {
    return data[0]
  }
  return null
}
